import { GetRowIdParams, GridReadyEvent, RowSelectedEvent } from "@ag-grid-community/core";
import { Location } from "@angular/common";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";

import { ActivatedRoute } from "@angular/router";
import { JoDetail } from "app/model/entities/jo-detail";
import { AgFns, GridOptionsExt, ISortModel } from "app/shared/ag-fns";
import { BarcodeService } from "app/shared/barcode.service";
import { DialogBaseComponent } from "app/shared/dialog-base.component";
import { EntityFns } from "app/shared/entity-fns";
import { NavFns } from "app/shared/nav-fns";
import { OneFieldDialogComponent } from "app/shared/one-field-dialog.component";
import { Guid } from "guid-typescript";
import _ from "lodash";
import { takeUntil } from "rxjs/operators";
import {
  BarcodePrintStatusEnum,
  InvoiceDetail,
  JoHeader,
  
  ReturnReasonType,
  ReturnRequest,
  ReturnRequestDetail,
  ReturnRequestDetailStatusEnum,
  ReturnRequestStatusEnum,
} from "../model/entities/entity-model";
import { DomainBaseComponent } from "../shared/domain-base.component";
import { DomainService } from "../shared/domain.service";
import { InvoiceDialogComponent } from "../shared/invoice-dialog.component";
import { ReturnRequestDetailDialogComponent } from "./return-request-detail-dialog.component";

@Component({
  selector: "app-jo-return-request",
  templateUrl: "./jo-return-request.component.html",

  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class JoReturnRequestComponent extends DomainBaseComponent implements OnInit {
  initReturnRequestId: number;

  rrGridOptions: GridOptionsExt;
  selectedReturnRequest: ReturnRequest;

  rrdGridOptions: GridOptionsExt;
  returnRequestDetails: ReturnRequestDetail[] = [];

  constructor(
    protected domainService: DomainService,
    protected barcodeService: BarcodeService,
    protected route: ActivatedRoute,
    private location: Location
  ) {
    super(domainService);

    this.route.queryParamMap.pipe(takeUntil(this.onDestroy)).subscribe(() => {
      this.updateFromContext();
    });
  }

  async updateFromContext() {
    this.rrGridOptions = AgFns.initGridOptions(this, {
      onGridReady: this.onRrGridReady,
      onRowSelected: this.onRrRowSelected,
      onFilterChanged: this.onRraFilterChanged,
      rowModelType: "serverSide",
    });
    AgFns.captureGridRouteParams(this.rrGridOptions, this.route, "id");

    // TODO: check this.
    const gridState = AgFns.getGridState(this.rrGridOptions);
    if (gridState && gridState.fm == null) {
      const returnRequestId = this.route.snapshot.queryParams["returnRequestId"];
      if (returnRequestId != null) {
        gridState.fm = AgFns.addFilterClause({}, "id", "number", returnRequestId);
      }
    }

    this.rrdGridOptions = AgFns.initGridOptions(this, {
      onGridReady: this.onRrdGridReady,
      getRowId: (params: GetRowIdParams) => params.data?.id.toString(),
    });

    
    await this.dbQueryService.getAll(ReturnReasonType);
    // await this.dbQueryService.getAll(ReturnRequestDetailStatus);

    this.isPageReady = true;
  }

  override async canDeactivate() {
    const ok = await super.canDeactivate();
    if (!ok) return false;
    this.uow.clearEntities(ReturnRequestDetail);
    this.uow.clearEntities(ReturnRequest);
    this.uow.clearEntities(JoDetail);
    this.uow.clearEntities(JoHeader);
    this.uow.clearEntities(InvoiceDetail);
    return true;
  }

  onRrGridReady(event: GridReadyEvent) {
    const colDefs = [
      {
        headerName: "Job Order",
        ...NavFns.createIdCellClickedNavProps("joHeaderId", this.router, "/in-process/manage/job-orders"),
        ...AgFns.fixWidth(160),
      },
      {
        headerName: "Account",
        field: "joHeader.account.accountName",
        filter: "agTextColumnFilter",
        ...AgFns.flexWidth(200),
      },
      {
        headerName: "Account User",
        colId: "accountUser",
        valueGetter: (params) => {
          const joh = <JoHeader>params.data.joHeader;
          return joh.getFormalEmployeeName();
        },
        ...AgFns.flexWidth(160),
      },
      // { ...AgFns.createSetFilterObjectProps('JO Status', 'joHeader.joStatus.name', this.dbQueryService.getAllCached(JoStatus)) },
      {
        headerName: "J/O Date",
        field: "joHeader.joDate",
        filter: "agDateColumnFilter",
        ...AgFns.fixWidth(180),
      },
      {
        headerName: "Return Req. Received",
        field: "receivedTs",
        filter: "agDateColumnFilter",
        ...AgFns.fixWidth(180),
      },
      {
        headerName: "Return Req. Status",
        field: "returnRequestStatus.name",
        filter: "agTextColumnFilter",
        ...AgFns.fixWidth(180),
      },
      // {
      //   headerName: "Return Address",
      //   field: "returnAddress1",
      //   filter: "agTextColumnFilter",
      // },
      // {
      //   headerName: "Return City",
      //   field: "returnCity",
      //   filter: "agTextColumnFilter",
      // },
      // { headerName: "Return State", field: "returnState" },
      // { headerName: "Return Zip", field: "returnZipCode" },
      // {
      //   headerName: "Return Request Id",
      //   field: "id",
      //   filter: "agNumberColumnFilter",
      // },
    ];
    const sortModel = [
      { colId: "receivedTs", sort: "desc" },
      { colId: "joHeader.account.accountName", sort: "asc" },
    ] as ISortModel;

    AgFns.initGrid(event, colDefs, sortModel);

    this.updateDatasource();
    AgFns.applyGridRouteParams(this.rrGridOptions);
  }

  updateDatasource() {
    const gridApi = this.rrGridOptions.apiX;
    if (gridApi == null) {
      return;
    }
    const ds = AgFns.buildDatasource(() => this.dbQueryService.createReturnRequestQuery());
    gridApi.setGridOption("serverSideDatasource", ds);
  }

  onRrdGridReady(event: GridReadyEvent) {
    const colDefs = [
      {
        ...AgFns.createButtonProps("", this.editReturn.bind(this), {
          label: "Edit",
          calcLabel: (x: ReturnRequestDetail) => (x.returnRequestDetailStatus.isFinalState ? "View" : "Edit"),
        }),
        ...AgFns.fixWidth(80),
      },
      {
        ...AgFns.createButtonProps("", this.split.bind(this), {
          label: "Split",
          canDisplay: (x: ReturnRequestDetail) => x.qty > 1 && !x.returnRequestDetailStatus.isFinalState,
        }),
        ...AgFns.fixWidth(80),
      },
      {
        headerName: "Manufacturer",
        field: "joDetail.product.productType.manufacturer.name",
        ...AgFns.flexWidth(180),
      },
      { headerName: "SKU", field: "joDetail.product.productType.style", ...AgFns.flexWidth(160) },
      {
        headerName: "Description",
        field: "joDetail.product.productType.description",
        ...AgFns.flexWidth(200),
      },
      {
        headerName: "Features",
        field: "joDetail.product.featureChoicesExtract",
        ...AgFns.flexWidth(140),
      },
      { headerName: "Qty", field: "qty", ...AgFns.fixWidth(120) },
      { headerName: "Status", field: "returnRequestDetailStatus.name", ...AgFns.fixWidth(180) },
      { headerName: "Return Type", field: "returnReasonType.name", ...AgFns.fixWidth(160) },
      { headerName: "Return Explanation", field: "returnExplanation", ...AgFns.flexWidth(200) },
      {
        headerName: "Credit Amt/Unit (default)",
        field: "defaultUnitCreditAmt",
      },
      {
        headerName: "Actual Amt/Unit (default)",
        field: "actualUnitCreditAmt",
      },

      {
        headerName: "Invoice Ids",
        valueGetter: (params) => {
          const rrd = <ReturnRequestDetail>params.data;
          const idList = _.uniq(rrd.joDetail.invoiceDetails.map((invd) => invd.invoiceHeaderId))
            .sort()
            .join(", ");
          return idList;
        },
        ...NavFns.createCellClickedDialogProps((invoiceId) => this.openInvoiceDialog(invoiceId)),
      },

      // { headerName: 'Return Request Detail Id', field: 'id',  },
    ];
    const sortFields = [
      "joDetail.product.productType.manufacturer.name",
      "joDetail.product.productType.description",
      "joDetail.product.productType.style",
    ];
    const sortModel = sortFields.map((sf) => {
      return { colId: sf, sort: "asc" as const };
    });

    AgFns.initGrid(event, colDefs, sortModel);
  }

  updateLocation(key: any = null) {
    // Route was retired in favor of /returns-inbox; this component is no longer
    // routable. The self-replaceState is a no-op for grid state restoration here.
    const urlTree = this.router.createUrlTree(["/returns-inbox"]);
    const url = AgFns.buildGridRouteParamsUrl(urlTree, this.rrGridOptions, key && key.toString());
    this.domainService.location.replaceState(url);
  }

  async onRrRowSelected(e: RowSelectedEvent) {
    // check if a deselect event and ignore
    if (!e.node.isSelected()) {
      return;
    }
    const rr = e.data as ReturnRequest;
    if (!rr) {
      return;
    }
    this.selectedReturnRequest = rr;
    // locate rows by joHeaderId
    this.updateLocation(rr.id);

    await this.AgFns.busyGrid(this.rrdGridOptions, this, async () => {
      this.returnRequestDetails = await this.dbQueryService.getReturnRequestDetails(rr.id);
      AgFns.refreshGrid(this.rrdGridOptions, this.returnRequestDetails);
    });
  }

  async onRraFilterChanged() {
    this.updateLocation();
    // this.returnRequestDetails = [];
  }

  isRraInProcess() {
    return this.selectedReturnRequest.returnRequestStatusId === ReturnRequestStatusEnum.InProcess;
  }

  async openInvoiceDialog(invoiceId: string) {
    await InvoiceDialogComponent.openDialog(this.pngDialogService, { invoiceId });
  }

  async editReturn(rrad: ReturnRequestDetail) {
    await DialogBaseComponent.open(ReturnRequestDetailDialogComponent, this, {
      returnRequestDetail: rrad,
    });

    this.updateDatasource();
    AgFns.refreshGrid(this.rrdGridOptions, this.returnRequestDetails);
  }

  async split(rrad: ReturnRequestDetail) {
    const qty = await this.askSplitQty(rrad);
    if (qty == null) return;
    const clone = <ReturnRequestDetail>EntityFns.cloneStruct(rrad, ["id", "qty"]);
    const newRrad = this.dbSaveService.createEntity(ReturnRequestDetail, clone);
    newRrad.qty = qty;
    newRrad.proximityReturnRequestDetailId = Guid.create().toString();
    newRrad.proximityOrigReturnRequestDetailId = rrad.proximityOrigReturnRequestDetailId ?? rrad.proximityReturnRequestDetailId;
    rrad.qty = rrad.qty - qty;
    await this.dbSaveService.saveChanges();
    this.returnRequestDetails.push(newRrad);
    AgFns.refreshGrid(this.rrdGridOptions, this.returnRequestDetails);
  }

  async askSplitQty(rrad: ReturnRequestDetail) {
    while (true) {
      const r = await DialogBaseComponent.open(OneFieldDialogComponent, this, {
        title: `Enter quantity to split off`,
        fieldName: "Quantity ",
        fieldType: "integer",
      });
      if (r.index == 1) {
        return null;
      }
      if (r.value > 0 && r.value < rrad.qty) {
        return r.value;
      }
      this.toastr.warning(`Value must be between 0 and ${rrad.qty} exclusive.`);
    }
  }

  canPrintAnyRepairBarcodes() {
    return this.returnRequestDetails.some((rrad) => this.canPrintRepairBarcodes(rrad));
  }

  canPrintAnyItemDetailBarcodes() {
    return this.returnRequestDetails.some((rrad) => this.canPrintItemDetailBarcodes(rrad));
  }

  async printAllRepairBarcodes() {
    for (const rrad of this.returnRequestDetails) {
      if (this.canPrintRepairBarcodes(rrad)) {
        await this.printRepairBarcodes(rrad);
      }
    }
  }

  async printAllItemDetailBarcodes() {
    for (const rrad of this.returnRequestDetails) {
      if (this.canPrintItemDetailBarcodes(rrad)) {
        await this.printItemDetailBarcodes(rrad);
      }
    }
  }

  canPrintRepairBarcodes(rrad: ReturnRequestDetail) {
    return rrad.returnRequestDetailStatusId == ReturnRequestDetailStatusEnum.ReceivedRepairPending;
  }

  async printRepairBarcodes(rrad: ReturnRequestDetail) {
    // print special bar code - just info about Item and Repair request
    await this.barcodeService.printRepairBarcode(rrad);
  }

  canPrintItemDetailBarcodes(rrad?: ReturnRequestDetail) {
    return (
      rrad.returnedItemDetails?.length > 0 &&
      (rrad.returnRequestDetailStatusId == ReturnRequestDetailStatusEnum.ReceivedCreditApplied ||
        rrad.returnRequestDetailStatusId == ReturnRequestDetailStatusEnum.ReceivedAsAccountOwned)
    );
  }

  async printItemDetailBarcodes(rrad: ReturnRequestDetail) {
    const itemDetails = rrad.returnedItemDetails;
    if (itemDetails.length == 0) {
      return;
    }
    const printed = await this.barcodeService.printItemDetailBarcodes(itemDetails);
    if (printed) {
      const ok = await this.dialogService.yesNoDialog("Barcode Printing", `Did ${itemDetails.length} barcodes print correctly?`);
      if (ok) {
        itemDetails.forEach((itd) => (itd.barcodePrintStatusId = BarcodePrintStatusEnum.PrintedForStock));
        return true;
      }
    }
  }
}
